import { createFileRoute, redirect } from "@tanstack/react-router";
import { ConsignmentStockOutListPage } from "@/features/consignment-stockout/pages/ConsignmentStockOutListPage";

export const Route = createFileRoute("/admin/consignment-stockout/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_out.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockOutListPage,
});
